(function() { window.GUID_74f00bc2_7798_414d_92a9_b7788fbcb3a8 = { getGuid: function() { return "74f00bc2-7798-414d-92a9-b7788fbcb3a8"; } }; })();
var CS;
(function (CS) {
    let Nav;
    (function (Nav) {
        function Go(url, data = null, source = Source.Standard, replacePopState = false) {
            if (!url) {
                console.warn("CS.Nav.Go empty url");
                return;
            }
            Nav.CurrentSource = source;
            if (CS.DOM.$body)
                CS.DOM.$body.trigger('ajaxnavigating');
            if (url.endsWith('/x')) {
                const errorTrace = new Error().stack;
                CS.Analytics.Error('url ends with /x - ' + errorTrace, 'FORDEBUG');
            }
            CS.Views.MasterPage.Instance.Refreshing();
            if (replacePopState) {
                console.info("replacing url: " + window.location.href);
                console.info("replacing newurl: " + url);
                //window.location.replace(url);
                //return;
            }
            if (CS.GlobalConst.ForceFullNavigation) {
                window.location.href = url;
                return;
            }
            if (CS.CommonData.Current.IsNativeApp) {
                CS.NativeApp.NA_Navigating(url);
            }
            data = data !== null && data !== void 0 ? data : {};
            if (source == Source.Pop) {
                data.GoBack = true;
            }
            CS.Ajax.AjaxNavigationCall(url, data, source, (response, headervalues) => {
                var _a, _b;
                if (source == Source.Standard || source == Source.Post) {
                    if (headervalues.newUrl != "nonav") {
                        CS.PopState.OnNavigation((_a = headervalues.newUrl) !== null && _a !== void 0 ? _a : url, replacePopState);
                    }
                }
                if (CS.CommonData.Current.IsNativeApp) {
                    CS.NativeApp.NA_Navigated((_b = headervalues.newUrl) !== null && _b !== void 0 ? _b : url);
                }
                ResetAfterMiddleRefresh();
            }, replacePopState);
        }
        Nav.Go = Go;
        function ResetAfterMiddleRefresh() {
            CS.CSS.ResetFileLoadedCount();
            CS.DOM.RebindSectionMasterJQueryContents();
        }
        Nav.ResetAfterMiddleRefresh = ResetAfterMiddleRefresh;
        function ForceFullRefresh() {
            window.location.reload();
        }
        Nav.ForceFullRefresh = ForceFullRefresh;
        function Refresh(headerData = null, refreshUrl = "") {
            //console.log('Refresh ' + CS.CommonData.Current.IsPremiumTempUnlocked);
            if (CS.CommonData.Current.IsNativeApp && ($('.popupwizard').length > 0 || CS.CommonData.Current.IsPremiumTempUnlocked)) {
                //Ne pas raffraichir si popupwizard est affiché en nativeapp ou si en try premium
                //doit retourner true pour que xamarin detecte que ca marche
                console.log('not refreshing for specific case');
                return true;
            }
            if (refreshUrl == null || refreshUrl == "") {
                refreshUrl = window.location.href;
            }
            CS.Nav.Go(refreshUrl, headerData, Source.Refresh);
            //doit retourner true pour que xamarin detecte que ca marche
            return true;
        }
        Nav.Refresh = Refresh;
        function GoBack() {
            console.info("GoBack " + window.history.state);
            if (window.history.state) {
                let state = JSON.parse(history.state);
                if ((state && state.id == 1) || CS.PopState.getPopStateListenersLength() <= 1) {
                    console.info("No back history: GoBack to default");
                    CS.Nav.Go(CS.Url.BaseUrl(), null, Source.Standard, true);
                    return;
                }
                sessionStorage['app-button-back'] = 'true';
                window.history.back();
            }
            else {
                console.info("GoBack to default");
                this.GoToDefault();
            }
        }
        Nav.GoBack = GoBack;
        function GoToDefault() {
            console.info("GoToDefault");
            CS.Nav.Go(CS.Url.BaseUrl());
        }
        Nav.GoToDefault = GoToDefault;
        function GoAndResetHistory(url) {
            console.info("GoAndResetHistory to: " + url);
            CS.PopState.resetNavigationStack(url);
            CS.Nav.Go(url, null, Source.Standard, true);
        }
        Nav.GoAndResetHistory = GoAndResetHistory;
        let Source;
        (function (Source) {
            Source[Source["Standard"] = 0] = "Standard";
            Source[Source["Post"] = 1] = "Post";
            Source[Source["Pop"] = 2] = "Pop";
            Source[Source["Refresh"] = 3] = "Refresh";
        })(Source = Nav.Source || (Nav.Source = {}));
    })(Nav = CS.Nav || (CS.Nav = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-nav.js.map
